/* tslint:disable:no-shadowed-variable */
import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { WatchListState, WatchStatusTypes } from './types'
import { ActionNames, MutationNames } from './keys'
import { getters } from './getters'
import { getWatchListQuery, patchWatchListQuery, postWatchListQuery } from '@/jsonapi/WatchList'

const state: WatchListState = {
  watchLists: [],
}

const mutations = {
  [MutationNames.updateWatchLists](state, payload) {
    state.watchLists = payload
  },
}

const actions = {
  async [ActionNames.getWatchLists]({ commit, rootState }): Promise<void> {
    const result = camelcaseKeysDeep(
      await getWatchListQuery({
        userId: rootState[ModuleNames.app].userId,
      })
    )
    commit(MutationNames.updateWatchLists, result)
  },
  async [ActionNames.postWatchList](
    { commit, rootState },
    payload: { patientId: string; watchStatus: WatchStatusTypes.MANUAL | WatchStatusTypes.UNWATCH }
  ): Promise<void> {
    await postWatchListQuery({
      attributes: {
        userId: rootState[ModuleNames.app].userId,
        uid: rootState[ModuleNames.app].userId,
        patientId: payload.patientId,
        watchStatus: payload.watchStatus,
      },
    })
  },
  async [ActionNames.patchWatchList](
    { commit, rootState },
    payload: { id: string; watchStatus: WatchStatusTypes.MANUAL | WatchStatusTypes.UNWATCH }
  ): Promise<void> {
    await patchWatchListQuery({
      id: payload.id,
      attributes: {
        userId: rootState[ModuleNames.app].userId,
        uid: rootState[ModuleNames.app].userId,
        watchStatus: payload.watchStatus,
      },
    })
  },
}

export default {
  name: ModuleNames.watchList,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
